import { Link, useNavigate } from "react-router-dom";
import { Moon, Sun, LogIn, LayoutGrid } from "lucide-react";
import Logo from "@/components/Logo";
import { useTheme } from "@/context/ThemeContext";
import { useAuth } from "@/context/AuthContext";

export default function PublicHeader() {
  const { theme, toggle } = useTheme();
  const { user } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-40 glass border-b border-panel-border bg-panel-header/80">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-logo-link"><Logo size="md" /></Link>
        <nav className="hidden md:flex items-center gap-7 text-sm font-medium text-panel-secondary">
          <Link to="/" className="hover:text-brand-500 transition-colors">Ana Sayfa</Link>
          <Link to="/#servisler" className="hover:text-brand-500 transition-colors">Servisler</Link>
          <Link to="/blog" className="hover:text-brand-500 transition-colors" data-testid="nav-blog">Blog</Link>
          <Link to="/#sss" className="hover:text-brand-500 transition-colors">S.S.S</Link>
        </nav>
        <div className="flex items-center gap-2">
          <button onClick={toggle} data-testid="theme-toggle" className="h-10 w-10 grid place-items-center rounded-xl card hover:border-brand-500 transition-colors">
            {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          {user ? (
            <button onClick={() => nav("/panel/satin-al")} data-testid="header-panel-btn" className="btn-blue rounded-xl px-4 h-10 text-sm font-semibold flex items-center gap-2">
              <LayoutGrid size={16} /> Panelim
            </button>
          ) : (
            <>
              <Link to="/giris" data-testid="header-login-btn" className="hidden sm:flex items-center gap-2 h-10 px-4 rounded-xl card text-sm font-semibold hover:border-brand-500 transition-colors">
                <LogIn size={16} /> Giriş
              </Link>
              <Link to="/kayit" data-testid="header-register-btn" className="btn-blue rounded-xl px-4 h-10 text-sm font-semibold grid place-items-center">Üye Ol</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
